import type { MeResponse } from "../../api/types";
import { hasPermission } from "../../auth/permissions";
import { ForbiddenPage } from "../ForbiddenPage";
import { DepartmentsPage } from "./DepartmentsPage";
import { PositionsListPage } from "./PositionsListPage";

// HiringPage dispatches on path like AdminPage. Position detail is a modal
// inside PositionsListPage, so the only routes are /hiring and
// /hiring/departments — there is no /hiring/{id}.
export function HiringPage({ me, path }: { me: MeResponse; path: string }) {
  if (path === "/hiring/departments") {
    if (!hasPermission(me, "departments:manage")) {
      return <ForbiddenPage me={me} />;
    }
    return <DepartmentsPage />;
  }
  return <PositionsListPage me={me} />;
}
